import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentRemove from 'material-ui/svg-icons/content/remove-circle';

/**
 * A component for creating a Product Unit row with deletion for Transfer lists.
 * Loaded by NewTransferProductUnitTable.
 *
 */
class NewTransferProductUnitTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleDeleteClick() {
        this.props.onDeleteClick(this.props.data);
    }

    render() {
        const styles = {
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            row: {height: '40px'},
        };
        return (
            <TableRow style={styles.row}>
                <TableRowColumn className={'row-item-' + this.props.data.barcode} style={styles.row}>
                    <span>{this.props.data.barcode}</span>
                </TableRowColumn>

                <TableRowColumn className={'row-qty-' + this.props.data.barcode} style={styles.row}>
                    <span>{this.props.data.qty}</span>
                </TableRowColumn>

                <TableRowColumn style={styles.row}>
                    <IconButton style={styles.icon} onClick={(e) => this.handleDeleteClick(e)}>
                        <ContentRemove color={FuseTheme.palette.primary1Color}/>
                    </IconButton>
                </TableRowColumn>
            </TableRow>
        )
    }
}

NewTransferProductUnitTableRow.propTypes = {
    addField: PropTypes.bool,
    data: PropTypes.object.isRequired,
    onDeleteClick: PropTypes.func,
};

NewTransferProductUnitTableRow.defaultProps = {
    addField: true,
    style: {padding: 0},
};

export default NewTransferProductUnitTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/NewTransferProductUnitTableRow.js